import { useNavigate } from "react-router-dom";

const NoData = ({ title, desc, icon, btn, style = {} }) => {
    const navigate = useNavigate();
    return (
        <div
            style={{
                ...style,
                minHeight: "200px",
                textAlign: "center",
                padding: "40px 20px",
            }}
        >
            {icon && <i className={`icon ${icon} `} />}
            <h2 className="title title-16">{title}</h2>
            <p className="subtitle-12">{desc}</p>
            {btn && (
                <div className="btn-wrap btn-wrap-no-Xpadding">
                    <button
                        className="btn btn-small btn-fit btn-border-8 btn-outline-purple500"
                        onClick={() => {
                            if (btn.link.includes("http")) {
                                window.open(btn.link, "_blank");
                            } else {
                                navigate(btn.link);
                            }
                        }}
                    >
                        {btn.name}
                    </button>
                </div>
            )}
        </div>
    );
};

export default NoData;
